export default __webpack_public_path__ + "static/media/fleep.367c52b2.svg";